const root =
    process.env.NODE_ENV === "production" ? require("./Root.prod.jsx").default : require("./Root.dev.jsx").default;

export default root;
